import React from 'react';
import styles from './styles.module.scss';
import { Button, TextField } from '@mui/material';
import { useState } from 'react';

import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useTranslation } from '../../../i18n/LanguageProvider';

const UserInfo = ({ onSubmitUser, loading }) => {
  const { t } = useTranslation();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (confirmPassword !== password) {
      toast.error(t('auth.passwordMismatch'));
      return;
    }

    onSubmitUser({
      firstName,
      lastName,
      password
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <p className={styles.validationDescription}>
          {t('auth.enterRegisterInfo')}
        </p>
      </div>

      <TextField
        className={styles.formItem}
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
        fullWidth
        label={t('auth.firstName')}
        autoComplete="given-name"
        id="name"
      />

      <TextField
        className={styles.formItem}
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
        fullWidth
        label={t('auth.lastName')}
        autoComplete="family-name"
        id="last-name"
      />

      <TextField
        className={styles.formItem}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        fullWidth
        label={t('auth.registerPassword')}
        autoComplete="new-password"
        type="password"
        id="password"
        ltr
      />

      <TextField
        className={styles.formItem}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        fullWidth
        label={t('auth.registerConfirmPassword')}
        autoComplete="new-password"
        type="password"
        id="confirm-password"
        ltr
      />

      <Button
        fullWidth
        variant="contained"
        className={styles.formItem}
        disabled={loading}
        type="submit"
      >
        {t('auth.register')}
      </Button>
    </form>
  );
};

UserInfo.propTypes = {
  onSubmitUser: PropTypes.func,
  loading: PropTypes.bool
};

export default UserInfo;
